import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Button from '../../buttons/Button';//eslint-disable-line import/no-named-as-default
import AssetImage from './AssetImage';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../actions/dialogPopupActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import {ASSET_CONFIG} from '../../../models/dialogModels';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class SecondaryImage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            image: {},
            screenStatus:"",
            checkComplete: false,
            continue_label: appHelper.getLocaleString("continue_label")

        };
        this.getAssets = this.getAssets.bind(this);
        this.show = this.show.bind(this);
        this.setClass = this.setClass.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onCloseAssetDialog = this.onCloseAssetDialog.bind(this);
        this.launchAsset = this.launchAsset.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {
        this.getAssets();

    }



    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            let image = appHelper.getImageAsset(this.state.screenObject);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image,
                continue_label: appHelper.getLocaleString("continue_label")
            });
        }
    }

    componentDidUpdate(){

    }


    getAssets() {
        let image = appHelper.getImageAsset(this.state.screenObject);
        this.setState({image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image});

    }

    show() {
        let fileRef = this.refs[`image_${this.state.screenObject.asset_id}`];
        if (appHelper.isDefined(fileRef)) {
            TweenLite.set(fileRef, {opacity: 1, height: "auto"});
            TweenLite.from(fileRef, 1, {
                height: 0,
                opacity: 0,
                ease: Expo.easeInOut
            });
        }
    }

    scrollToTop() {

    }


    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setClass() {
        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        } else {
            return "not-started";
        }
    }


    onCloseAssetDialog(viewed){
        /*let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);
        if(objectUserData.status !== objectConstants.STATUS_COMPLETE && viewed) {
            this.updateResourceObjectResult();
        }*/
    }

    launchAsset(){
        let childComponenents = [];
        let config = Object.assign({}, ASSET_CONFIG,
            {
                title: this.state.locale.label,
                onClose: this.onCloseAssetDialog,
                showCloseBtn: false,
                theme: "dialog-asset-image",
                sourceId: `image_btn_${this.state.screenObject.asset_id}`
            }
        );

        for (let i = 0; i < config.childComponents.length; i++) {
            let child = config.childComponents[i];
            child = Object.assign({},child,{
                childComponent: AssetImage,
                componentProps: Object.assign({}, {
                    screenObject: this.state.screenObject,
                    callbacks:{}

                })
            });

            childComponenents = dataHelper.immutablePush(childComponenents, child);
        }
        config = Object.assign({},config,{
            childComponents: childComponenents
        });

        this.props.actions.setNewAssetDialog(config);
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.launchAsset();
        }
    }

    render() {
        return (

            <div className="object-container" ref={`image_${this.state.screenObject.asset_id}`} >
                <div className={`asset-image`} onClick={this.launchAsset} id={`image_btn_${this.state.screenObject.asset_id}`} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={0}>
                    <div className="img-container">
                        <img src={this.getImagePath(this.state.image.src)} alt={this.state.locale.label} id={appHelper.isDefined(this.props.id) ? this.props.id : `image_${this.state.screenObject.asset_id}`}/>
                    </div>
                    <div className="asset-desc">
                        {
                            appHelper.isDefined(this.state.locale.label) && this.state.locale.label.length > 0
                                ?
                                <div className="title" dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                                :
                                null
                        }
                        {
                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                ?
                                <div className="desc-text" dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                :
                                null
                        }
                    </div>
                </div>
                {this.state.showProgressionButton
                    ? <Button label={this.state.continue_label}
                              id={`${this.state.screenObject}_button`}
                              onClick={this.onProgressionBtnClicked}/>
                    : null
                }
            </div>

        );
    }
}

SecondaryImage.propTypes = {
    screenObject: PropTypes.object.isRequired,
    id:PropTypes.string,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

SecondaryImage.contextTypes = {
    router: PropTypes.object
};

/*
* <ParagraphText screenObject={this.state.screenObject}
                                   ref={`${this.state.screenObject.asset_id}_paragraph`}
                                   id={`${this.state.screenObject}_description`}
                                   class_name="document-description"
                                   objectKey={`description`}/>*/

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryImage);



/** WEBPACK FOOTER **
 ** ./src/components/objects/image/SecondaryImage.js
 **/